"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumn;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIMultiColumn(props) {
  var children = props.children,
      className = props.className,
      flush = props.flush,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "flush"]);
  return _react.default.createElement("div", Object.assign({}, other, {
    className: (0, _classnames.default)('private-multicolumn', className, flush && 'private-multicolumn--flush')
  }), children);
}

UIMultiColumn.displayName = 'UIMultiColumn';
UIMultiColumn.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired
};
UIMultiColumn.defaultProps = {
  flush: false
};
module.exports = exports.default;